module.exports = __webpack_public_path__ + "img/gn.121f77fd.png";